document.addEventListener('click', (event) => {
  const controls = event.target.closest('[data-bestio-listing-controls]');
  if (!controls) return;

  const sortPanel = controls.querySelector('[data-bestio-sort-tabs]');
  const sortOpenButton = event.target.closest('[data-bestio-mobile-sort-open]');
  const sortCloseButton = event.target.closest('[data-bestio-mobile-sort-close]');
  if (sortOpenButton && sortPanel) {
    sortPanel.classList.add('is-mobile-sort-open');
    sortOpenButton.setAttribute('aria-expanded', 'true');
    return;
  }
  if (sortCloseButton && sortPanel) {
    sortPanel.classList.remove('is-mobile-sort-open');
    controls.querySelector('[data-bestio-mobile-sort-open]')?.setAttribute('aria-expanded', 'false');
    return;
  }

  const sortButton = event.target.closest('[data-sort-value]');
  const pageSizeButton = event.target.closest('[data-page-size]');
  if (!sortButton && !pageSizeButton) return;

  const url = new URL(window.location.href);
  url.searchParams.delete('page');
  if (controls.dataset.listingKind === 'search') {
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'last');
  }
  if (sortButton) url.searchParams.set('sort_by', sortButton.dataset.sortValue);
  if (pageSizeButton) {
    const view = pageSizeButton.dataset.templateView;
    if (view) url.searchParams.set('view', view);
    else url.searchParams.delete('view');
  }
  window.location.href = url.toString();
});
